export default {
    apiUrl: process.env.REACT_APP_API_BASE || 'https://upp3v7v5dj.execute-api.eu-west-1.amazonaws.com/develop',
    appUrl: process.env.REACT_APP_APP_BASE || 'http://localhost:3000',
    redirectUrl: process.env.REACT_APP_REDIRECT_BASE || 'http://localhost:3000',
    tokenKey: process.env.REACT_APP_TOKEN_KEY || 'o',
    admin: process.env.REACT_APP_ADMIN,
    adminKey: process.env.REACT_APP_ADMIN_KEY
};